import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-products-list-style-two',
  templateUrl: './products-list-style-two.component.html',
  styleUrls: ['./products-list-style-two.component.scss']
})
export class ProductsListStyleTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
